import { extendTheme } from '@chakra-ui/react'

export const theme = extendTheme({
  fonts: {
    heading: "'Barlow-Medium', sans-serif",
    body: "'Barlow-Light', sans-serif",
  },
  colors: {
    orange: {
      500: '#FAA957',
      600: '#F87A39',
      50: '#EEA254',
    },
    brand: {
      white: 'white',
      blue: '#235480',
      darkBlue: '#163652',
      blueGradient: 'linear-gradient(146.62deg, #235480 0%, #19446A 100%);',
      textBlue: '#57596E',
      textDarkBlue: '#37374D',
      lightMarineBlue: '#edf2f7',
      lightBlue: '#D0E4F6',
      lightBlueGradient: 'linear-gradient(100deg, #D0E4F6 0%, #B6CFE6 100%);',
      lightGray: 'rgba(232,233,239,0.49)',
      lightestGray: '#F7F7F7',
      gray: '#D9D9D9',
      textGray: '#9B9BA7',
      darkGray: '#64646c',
      orange: '#F87A39',
      lightOrange: '#EEA254',
      deepOrange: '#FAA957',
      lightestOrange: '#fff3e7',
      brightBlue: '#7ca5ff',
      grayDivider: 'rgba(86,94,117,0.5)',
      red: 'rgb(248,66,100)',
      lightRed: 'rgba(250,201,209,0.29)',
      darkRed: 'rgb(147,52,72)',
      green: 'rgb(49,199,96)',
      darkGreen: 'rgb(39,154,75)',
      secondaryGray: 'rgb(198,199,210)',
      lightYellow: 'rgba(255,213,0,0.25)',
    },
  },
  layerStyles: {
    iconsContextMenu: {
      size: 20,
    },
    checkbox: {
      border: '0px solid #37374D',
      borderRadius: 2,
      outline: 0,
      '& .chakra-checkbox__control': {
        boxShadow: '0 4px 10px rgba(0, 0, 0, .1)',
      },
    },
    checkboxChecked: {
      '& .chakra-checkbox__control': {
        boxShadow: '0 4px 10px rgba(0, 0, 0, .1)',
        backgroundColor: '#37374D',
      },
    },
    cancelButton: {
      borderRadius: '4px',
      backgroundColor: '#FFFFFF',
      height: '50px',
      width: '100%',
      color: 'black',
      paddingLeft: '12px',
      paddingRight: '12px',
    },
    cancelButtonHover: {
      backgroundColor: '#DFDFDF',
    },
    listBox: {
      flexDirection: 'column',
      h1: {
        fontFamily: 'Barlow-Medium',
        fontSize: '18px',
        fontWeight: 'bold',
      },
      '.list': {
        flexDirection: 'column',
        border: 'solid #D9D9D9 1px',
        padding: '10px 0px 10px 0px',
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        overflowY: 'auto',
        div: {
          cursor: 'pointer',
          margin: '0px 0px 2px 0px',
          paddingLeft: '10px',
          '&.selected': {
            backgroundColor: '#37374D',
            color: 'white',
          },
          '&.default': {
            textDecoration: 'underline',
            fontWeight: 'bold',
          },
        },
      },
    },
    drawer: {
      '& .chakra-modal__content-container': {
        width: 'auto!important',
      },
    },
  },
  textStyles: {
    link: {
      color: '#F87A39',
      textDecoration: 'underline',
      fontSize: '14px',
      lineHeight: '19px',
    },
    darkLink: {
      textDecoration: 'underline',
      fontSize: '18px',
    },
    span: {
      fontSize: '18px',
      lineHeight: '20px',
    },
    h1: {
      fontWeight: 'bold',
      fontSize: '36px',
      lineHeight: '39px',
    },
    h2: {
      fontWeight: 'bold',
      fontSize: '21px',
      lineHeight: '28px',
    },
    h3: {
      fontWeight: 'bold',
      fontSize: '18px',
      lineHeight: '22px',
    },
    p: {
      fontSize: '16px',
      lineHeight: '25px',
    },
    menuHeader1: {
      fontSize: '17px',
      fontWeight: 'bold',
      lineHeight: '18px',
    },
    menuHeader2: {
      fontSize: '15px',
      fontWeight: 'bold',
      lineHeight: '18px',
    },
    menuHeader3: {
      fontSize: '14px',
      lineHeight: '20px',
    },
    menuHeaderTable1: {
      fontSize: '17px',
      fontWeight: 'bold',
      lineHeight: '18px',
    },
    menuHeaderTable2: {
      fontSize: '14px',
      lineHeight: '20px',
    },
    menuHeaderTable3: {
      fontSize: '14px',
      lineHeight: '20px',
    },
    heading: {
      fontWeight: 'bold',
      fontSize: '24px',
      lineHeight: '26px',
    },
    button: {
      fontWeight: 'bold',
      fontSize: '16px',
    },
    buttonLink: {},
    chartGroupHeader: {
      fontWeight: 'bold',
      fontSize: '21px',
      lineHeight: '23px',
    },
    childChartHeader: {
      fontFamily: "'Barlow-Medium', sans-serif",
      fontSize: '17px',
    },
    tinyHeader: {
      fontWeight: 'bold',
      fontSize: '13px',
      lineHeight: '18px',
    },
    comments: {
      fontSize: '14px',
      lineHeight: '19px',
    },
    chartTitle: {
      fontSize: '17px',
      lineHeight: '23px',
      fontWeight: 'bold',
    },
  },
  effects: {
    shadow: '0 3px 6px 0 rgba(0,0,0,0.2)',
  },
})
